// extracted by mini-css-extract-plugin
export default {"Container":"planning_Container__Ha8qs","section-1":"planning_section-1__YClmd","content":"planning_content__xKCFo","section-2":"planning_section-2__NXihS"};